import { useQuery } from '@tanstack/react-query';

import { api, getQueryProps, isTruthy } from 'common';

import { SubFlowContent } from './Content.tsx';

interface SubFlowPreviewProps {
  flowDefinitionId: string | undefined;
}

export function SubFlowPreview(props: SubFlowPreviewProps) {
  const { flowDefinitionId } = props;
  const { data, isSuccess } = useQuery({
    ...getQueryProps(
      api.client.FlowDefinition,
      'findOneById',
      flowDefinitionId ?? 'INVALID_FLOW_DEFINITION_ID'
    ),
    enabled: isTruthy(flowDefinitionId),
  });
  if (!isSuccess) {
    return;
  }

  return <SubFlowContent flowDefinition={data} />;
}
